import { Alert, AlertTitle, Box, Typography } from '@mui/material';

import { triggerFitScoreSurvey } from '../ProjectsTable/functions';
import { useReactiveVar } from '@apollo/client/react';
import { reactiveVars, UserDetailsProps } from '@brainpool/apollo-connect';
interface FitScoreNotificationProps {
  title?: string;
  message?: string;
  buttonText?: string;
  buttonColor?:
    | 'primary'
    | 'secondary'
    | 'inherit'
    | 'default'
    | 'error'
    | 'info'
    | 'success'
    | 'warning';
  alertType?: 'error' | 'info' | 'success' | 'warning';
  survey_responses: Record<string, any> | undefined;
}

export function FitScoreNotification({
  title = 'FIT SCORE SURVEY IS INCOMPLETE',
  message = 'Once completed, new projects will be assessed against your investment criteria.',
  buttonText = 'Click here to fill in the survey',
  buttonColor = 'success',
  alertType = 'warning',
  survey_responses,
}: FitScoreNotificationProps) {
  const currentUser = useReactiveVar<UserDetailsProps>(reactiveVars.userDetails);

  if (survey_responses) return null;

  return (
    <Box
      sx={{ mb: 2, position: 'relative' }}
      onClick={() => triggerFitScoreSurvey(currentUser?.orgId, currentUser?.userId)}
    >
      <Alert severity={alertType}>
        <AlertTitle>{title}</AlertTitle>
        <Typography variant="body2" sx={{ mb: 1 }}>
          {message}
        </Typography>
        <Typography variant="body2" color={buttonColor} sx={{ mt: 1 }}>
          {buttonText}
        </Typography>
      </Alert>
    </Box>
  );
}

export default FitScoreNotification;
